import "react-toggle/style.css";
import "./Styles/create-new-channel.scss";
import React from "react";
import { Row, Col } from "react-bootstrap";
import AddNewChannel from "./AddNewChannel";
import { useParams } from "react-router-dom";

function CreateChannel(props) {
  const { id } = useParams();

  return (
    <Row>
      <Col md={9}>
        <AddNewChannel fromListing={true} id={id} />
      </Col>
    </Row>
  );
}

export default CreateChannel;
